import AxiosInstance from './api';

export const AccountingDocumentRegisterService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get('/private/accounting-document-register', {
      params: query,
    });
  },
};
